(() => {
  const html = document.documentElement;

  const qs = (s, r = document) => r.querySelector(s);

function openSidecar() {
  const sidecar = qs('.eme-filter-sidecar');
  const backdrop = qs('.eme-filter-backdrop');
  if (!sidecar || !backdrop) return;

  sidecar.hidden = false;
  backdrop.hidden = false;
  sidecar.setAttribute('aria-hidden', 'false');

  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      html.classList.add('eme-filter-open');
    });
  });
}

function closeSidecar() {
  const sidecar = qs('.eme-filter-sidecar');
  const backdrop = qs('.eme-filter-backdrop');
  const panel = qs('.eme-filter-panel');
  if (!sidecar || !backdrop || !panel) return;

  html.classList.remove('eme-filter-open');
  sidecar.setAttribute('aria-hidden', 'true');

  const onEnd = (e) => {
    if (e.propertyName !== 'transform') return;
    panel.removeEventListener('transitionend', onEnd);
    sidecar.hidden = true;
    backdrop.hidden = true;
  };
  panel.addEventListener('transitionend', onEnd);
}

  document.addEventListener('click', (e) => {
    if (e.target.closest('.eme-filter-trigger')) {
      e.preventDefault();
      openSidecar();
      return;
    }

    if (e.target.closest('.eme-filter-close')) {
      e.preventDefault();
      closeSidecar();
      return;
    }

    if (e.target.classList && e.target.classList.contains('eme-filter-backdrop')) {
      closeSidecar();
      return;
    }

    const sidecar = qs('.eme-filter-sidecar');
    const panel = qs('.eme-filter-panel');
    if (html.classList.contains('eme-filter-open') && sidecar && panel) {
      if (sidecar.contains(e.target) && !panel.contains(e.target)) closeSidecar();
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeSidecar();
  });

  // APPLY = form submit (GET)
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.eme-filter-apply');
    if (!btn) return;

    const form = qs('#FacetFiltersFormMobile');
    if (!form) return;

    form.submit();
  });
})();

document.addEventListener('DOMContentLoaded', () => {
  document.addEventListener(
    'input',
    (e) => {
      const form = e.target.closest('form[data-eme-no-autosubmit="true"]');
      if (!form) return;
      e.stopImmediatePropagation();
    },
    true
  );
});

document.addEventListener('DOMContentLoaded', () => {
  const map = {
    black: '#111', siyah: '#111',
    white: '#fff', beyaz: '#fff',
    gray: '#8a8a8a', grey: '#8a8a8a', gri: '#8a8a8a',
    red: '#d11a2a', kirmizi: '#d11a2a', kırmızı: '#d11a2a',
    blue: '#1e4fd6', mavi: '#1e4fd6',
    green: '#1c8a3a', yesil: '#1c8a3a', yeşil: '#1c8a3a',
    beige: '#d8c7a6', bej: '#d8c7a6',
    brown: '#7a4a2a', kahverengi: '#7a4a2a',
    pink: '#f06aa6', pembe: '#f06aa6',
    purple: '#6b39c7', mor: '#6b39c7',
    yellow: '#f2c400', sari: '#f2c400', sarı: '#f2c400',
    orange: '#f07b18', turuncu: '#f07b18',
    navy: '#0b1e3a', lacivert: '#0b1e3a',
  };

  document.querySelectorAll('.eme-chip--swatch').forEach((chip) => {
    const raw = (chip.dataset.swatch || '').trim();
    const key = raw.toLowerCase();

    const isHex = /^#([0-9a-f]{3}|[0-9a-f]{6})$/i.test(raw);
    const color = isHex ? raw : (map[key] || null);

    const sw = chip.querySelector('.eme-swatch');
    if (!sw) return;

    if (color) {
      sw.style.background = color;
      if (color.toLowerCase() === '#fff' || color.toLowerCase() === '#ffffff') {
        sw.style.borderColor = 'rgba(0,0,0,.28)';
      }
    } else {
      sw.style.background = raw; 
    }

    chip.title = raw; 
  });
});

(function () {
  function toCents(v) {
    if (v == null) return "";
    const s = String(v).trim().replace(",", ".");
    if (s === "") return "";
    const n = Number(s);
    if (!isFinite(n)) return "";
    return String(Math.round(n * 100));
  }

  function restore(el, val) {
    if (val === undefined) return;
    el.value = val;
  }

document.addEventListener('click', (e) => {
  const btn = e.target.closest('.eme-filter-apply');
  if (!btn) return;

  const form = qs('#FacetFiltersFormMobile');
  if (!form) return;

  form.querySelectorAll('.eme-price-number').forEach((inp) => {
    if (String(inp.value || '').trim() === '') inp.disabled = true;
  });

  form.submit();
});

  document.addEventListener("click", function (e) {
    const btn = e.target.closest(".eme-filter-apply");
    if (!btn) return;

    const panel = btn.closest(".eme-filter-panel");
    if (!panel) return;

    const form = panel.querySelector("form");
    if (!form) return;

    const minInput = form.querySelector('.eme-price-number[data-role="min"]');
    const maxInput = form.querySelector('.eme-price-number[data-role="max"]');

    const minDisplay = minInput ? minInput.value : undefined;
    const maxDisplay = maxInput ? maxInput.value : undefined;

    if (minInput) minInput.value = toCents(minInput.value);
    if (maxInput) maxInput.value = toCents(maxInput.value);

    // form.submit();

    setTimeout(function () {
      if (minInput) restore(minInput, minDisplay);
      if (maxInput) restore(maxInput, maxDisplay);
    }, 0);
  });
})();

document.addEventListener('DOMContentLoaded', () => {
  const root = document;

  function syncChip(chip) {
    const input = chip.querySelector('.eme-chip-input');
    if (!input) return;
    chip.classList.toggle('is-active', !!input.checked);
  }

  function syncAll() {
    root.querySelectorAll('.eme-chip').forEach(syncChip);
  }

  syncAll();

  root.addEventListener('click', (e) => {
    const chip = e.target.closest('.eme-chip');
    if (!chip) return;

    const input = chip.querySelector('.eme-chip-input');
    if (!input || input.disabled) return;

    e.preventDefault();

    input.checked = !input.checked;
    input.dispatchEvent(new Event('change', { bubbles: true }));

    syncChip(chip);
  });

  root.addEventListener('change', (e) => {
    const input = e.target.closest('.eme-chip-input');
    if (!input) return;
    const chip = input.closest('.eme-chip');
    if (!chip) return;
    syncChip(chip);
  });

  root.addEventListener('click', (e) => {
    if (e.target.closest('.eme-filter-trigger')) {
      setTimeout(syncAll, 0);
    }
  });
});